export default 'M12 0a12 12 0 1 1 0 24 12 12 0 0 1 0-24m0 4a8 8 0 0 0 0 16 8 8 0 0 0 0-16m4 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0';